import { cn } from '@bem-react/classname';

export const cnPopup = cn('Popup2');
